export const LISTAR_EMPRESAS_ATIVAS = "LISTAR_EMPRESAS_ATIVAS";
